import { useMemo } from 'react';
import { DateValue, now, toZoned } from '@internationalized/date';
import { StartTimeSettingsType, SuggestedSettingsEnum } from '@lp/features/RoutePlanner/types';
import { formatDateTimeStringToTimeZone } from '@/utils/helpers';
import { DateTimeSettingsPopover } from './DateTimeSettingsPopover';
import { SettingsControlShell } from './SettingsControlShell';

type StartTimeSettingsProps = {
  data: StartTimeSettingsType;
  handleSettingsChange: (data: StartTimeSettingsType) => void;
};

export const StartTimeSettings = ({ data, handleSettingsChange }: StartTimeSettingsProps) => {
  const startTimeString = useMemo(() => {
    const utcString = data.value.toAbsoluteString();

    return formatDateTimeStringToTimeZone(utcString, data.value.timeZone);
  }, [data.value]);

  const handleStartTimeChange = (dateTime: DateValue) => {
    handleSettingsChange({
      type: SuggestedSettingsEnum.StartTime,
      value: toZoned(dateTime, data.value.timeZone),
    });
  };

  return (
    <SettingsControlShell>
      <div className="flex items-center gap-1">
        <span className="text-base-5 text-m-sb">Start Time:</span>
        <span className="text-base-5 text-m-r">{startTimeString}</span>
      </div>
      <DateTimeSettingsPopover
        value={data.value}
        timeInputLabel="Start time picker"
        minValue={now(data.value.timeZone)}
        onChange={handleStartTimeChange}
      />
    </SettingsControlShell>
  );
};
